// extracted by mini-css-extract-plugin
module.exports = {"title-color":"title-color-0d5ae89814852c3d7b2086de7610f0b8","num":"num-328f37528b079fdf7c4cab7894ea8491"};